module.exports = __webpack_public_path__ + "static/media/blue-plus.a42b5bc2.svg";